export const attributes = {
  formSuccess: "data-form-success",
  formError: "data-form-error",
  formParent: "data-form-container",
};
